import { motion } from 'framer-motion'
import { useInView } from './useInView'

const stats = [
  { value: 'React Native', label: 'Technologia mobilna' },
  { value: '.NET 8', label: 'Backend API' },
  { value: 'TPay', label: 'Platnosci online' },
  { value: 'Firebase', label: 'Powiadomienia push' },
]

export default function Stats() {
  const { ref, isInView } = useInView()

  return (
    <section className="relative py-24">
      <div className="absolute inset-0 bg-radial-center" />

      <div ref={ref} className="relative z-10 max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="rounded-3xl bg-white/[0.02] border border-white/[0.06] p-10 sm:p-14"
        >
          <div className="text-center mb-12">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3">
              Zbudowane na solidnych fundamentach
            </h3>
            <p className="text-zinc-400">
              Nowoczesny stack technologiczny gwarantujacy wydajnosc i
              bezpieczenstwo.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, i) => (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={isInView ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.5, delay: 0.2 + i * 0.1 }}
                className="text-center"
              >
                <div className="text-3xl sm:text-4xl font-extrabold text-gradient mb-2">
                  {stat.value}
                </div>
                <div className="text-sm text-zinc-500 font-medium">
                  {stat.label}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  )
}
